"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxiomQueryAbiForVersion = void 0;
const tslib_1 = require("tslib");
const AxiomV2Query_json_1 = tslib_1.__importDefault(require("./abi/AxiomV2Query.json"));
function getAxiomQueryAbiForVersion(version) {
    switch (version) {
        case "v2":
            return AxiomV2Query_json_1.default.abi;
        default:
            throw new Error(`Version ${version} does not have a Query ABI`);
    }
}
exports.getAxiomQueryAbiForVersion = getAxiomQueryAbiForVersion;
//# sourceMappingURL=abi.js.map